/**
 * Честный вход на Олимп, пока нет доказанного адреса матча.
 *
 * `undefined` в path — битая ссылка (`broken_link`). Раздел `/live` не
 * событие: тестер ищет строку, как на Positive. Id события — из payload.
 */

import { opponentOf } from './positiveDoor';

export { opponentOf };

const EXACT = new Set(['event', 'outcome', 'betslip']);

/**
 * Доказанный вход Олимпа, а не корень линии с завышенной точностью.
 *
 * Новый native-каталог строит `/live|line/{sport}/{competition}/{event}`.
 * Старые кадры ещё могут нести `/live/{slug}` — это тоже событие. Корни
 * `/live` и `/line`, чужой host и известные битые слага событием не считаем,
 * даже если старый producer ошибочно подписал их как `event`.
 */
export function olimpEventDoor(precision: string, url: string | null): boolean {
  if (!EXACT.has(precision) || url === null || /undefined|\bnull\b|\bnan\b/i.test(url)) {
    return false;
  }
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.toLowerCase().replace(/^www\./, '');
    const parts = parsed.pathname.split('/').filter(Boolean);
    return host === 'olimp.bet'
      && (parts[0] === 'live' || parts[0] === 'line')
      && parts.length >= 2;
  } catch {
    return false;
  }
}

export function olimpEntryNote(
  precision: string,
  url: string | null,
  name: string,
  opponent: string,
  eid?: string | null,
): string | null {
  return olimpEventDoor(precision, url) ? null : olimpFindLine(name, opponent, eid);
}

export function olimpFindLine(
  name: string,
  opponent: string,
  eid?: string | null,
): string {
  const pair = opponent && opponent !== name ? `${name} / ${opponent}` : name;
  const id = eid ? ` · id ${eid}` : '';
  return `лайв Олимпа — найди ${pair}${id}`;
}
